import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { TID } from "@/constants/coverifyIds";

const FAQS = [
  {
    q: "What is CoVerify?",
    a: "CoVerify is the connected identity verification product from CoSec Global. It combines biometric document checks, liveness detection and AML screening with centralised tracking and audit-ready records.",
  },
  {
    q: "Who is CoVerify for?",
    a: "CoVerify is built for UK accountants, company secretarial teams, ACSPs and corporate law practitioners who need scalable, inspection-ready identity verification workflows.",
  },
  {
    q: "Is CoVerify ECCTA and Companies House ready?",
    a: "Yes. CoVerify is aligned with the Economic Crime and Corporate Transparency Act (ECCTA) requirements and supports the personal-code workflows needed for Companies House identity verification.",
  },
  {
    q: "How long does a verification take?",
    a: "Most clients complete the full flow, document capture, selfie liveness and AML screening, in under five minutes on a mobile device or browser.",
  },
  {
    q: "Where is verification data stored?",
    a: "Verification data is processed by our ISO 27001 certified identity verification provider. CoVerify itself stores only the verification status, timestamps and a reference to the secure record, never raw document images.",
  },
  {
    q: "Does CoVerify integrate with the rest of CoSec Global?",
    a: "Yes. CoVerify connects directly with CoSec App and the wider CoSec Global compliance suite, so verifications are linked to entity, director and shareholder records automatically.",
  },
  {
    q: "Can I run high-volume verifications?",
    a: "Yes. CoVerify is designed to provide central visibility and scale across hundreds, or thousands, of verifications at once.",
  },
  {
    q: "How do I get started?",
    a: "Book a personalised walkthrough via CoSec Global's contact page and our team will help you configure CoVerify for your practice.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28">
      <div className="container-cv">
        <div className="max-w-3xl mx-auto text-center">
          <span className="section-eyebrow">FAQs</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.1]">
            Common questions
          </h2>
          <p className="mt-4 text-base md:text-lg text-muted-foreground">
            Everything you need to know about CoVerify, ID verification and ECCTA compliance.
          </p>
        </div>

        <div className="mt-12 max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={TID.faqItem(i + 1)}
                className="rounded-xl border border-border bg-white px-5 data-[state=open]:shadow-sm"
              >
                <AccordionTrigger className="text-left font-display font-bold text-primary hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-muted-foreground leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
